import React from "react";
import { useHistory } from "react-router-dom";

export function useEscapeToGoBack() {
  const history = useHistory();
  React.useEffect(() => {
    const escListener = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        history.goBack();
      }
    };
    window.addEventListener("keydown", escListener);
    return () => window.removeEventListener("keydown", escListener);
  }, []);
}
